module.exports = __webpack_public_path__ + "static/img/x.6352d99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/floating-button/x.png
// module id = VaQs
// module chunks = 46